import { createContext, FC, ReactNode, useContext } from 'react';
import { useStore } from 'zustand';

import { OrganizationFormState, OrganizationFormStoreApi } from '../stores/createOrganizationFormStore';

/**
 * 조직 정보 폼 store를 하위 트리에 주입한다.
 * store는 `organization` 인자가 필요하므로 소유 다이얼로그가 생성해 주입한다.
 */
const OrganizationFormContext = createContext<OrganizationFormStoreApi | null>(null);

export const OrganizationFormProvider: FC<{ store: OrganizationFormStoreApi; children: ReactNode }> = ({
  store,
  children,
}) => {
  return <OrganizationFormContext.Provider value={store}>{children}</OrganizationFormContext.Provider>;
};

/** 명령형 접근(제출 시 getState 등)이 필요할 때 store api를 반환한다. */
export function useOrganizationFormStoreApi(): OrganizationFormStoreApi {
  const store = useContext(OrganizationFormContext);
  if (!store) {
    throw new Error('useOrganizationFormStoreApi must be used within OrganizationFormProvider');
  }
  return store;
}

export function useOrganizationFormStore<U>(selector: (s: OrganizationFormState) => U): U {
  return useStore(useOrganizationFormStoreApi(), selector);
}
